import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  FormControl,
  Grid,
  Icon,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";
import EditText from "components/EditText";
import FAQSection from "components/Faqs";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState } from "react";

import settingsTableData from "layouts/settings/data/settingsTableData";
import VendorSettings from "components/VendorSettings";
import { useLazyGetCmsQuery } from "services/settings";
import ShowToast from "components/MDToast";
import { isString, useFormik } from "formik";
import * as Yup from "yup";
import { useSetVendorTimeMutation } from "services/settings";
import { useNavigate } from "react-router-dom";
import { isNumber } from "utils/validations";
import Loader from "helpers/constants/Loader";
import { useAllSupportMutation } from "services/settings";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import { useRevertSupportMutation } from "services/settings";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useLazyGetAllFaqQuery } from "services/settings";
import useTranslation from "hooks/Translation";

const Settings = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const [getCms] = useLazyGetCmsQuery();
  const [vendorTime] = useSetVendorTimeMutation();
  const [getAllFaqs] = useLazyGetAllFaqQuery();
  const [allSupport] = useAllSupportMutation();
  const [vendorResponse] = useRevertSupportMutation();
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState("");
  const [cmsData, setCmsData] = useState("");
  const [deliveryTime, steDeliveryTime] = useState("");
  const [supportData, setSupportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [error, setError] = useState(false);
  const [faq, setFaq] = useState([]);

  const handleClose = () => {
    setOpen(false);
    // formik.setFieldError("message", "");
  };

  const getAllFaqsHandler = async () => {
    setLoading(true);
    let body = {
      length: 10,
      start: 1,
      search: "",
    };
    try {
      const res = await getAllFaqs(body).unwrap();
      if (res?.status === 200) {
        setLoading(false);
        setFaq(res?.data?.response_object || []);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      responseTime: "",
      deliveryTime: "",
      deliveryFees: "",
    },
    validationSchema: Yup.object({
      responseTime: Yup.string().required("Response time is required"),
      deliveryTime: Yup.string().required("Average delivery time is required"),
      deliveryFees: Yup.string().required("Delivery fees is required"),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      let body = {
        response_time: formik?.values?.responseTime,
        avg_delivery_time: formik?.values?.deliveryTime,
        delivery_fees: formik?.values?.deliveryFees,
      };

      try {
        const response = await vendorTime(body).unwrap();

        // return;
        if (response?.status === 200) {
          ShowToast(t.main.cmsUpdated);
        } else {
          ShowToast(response?.message || "Something went wrong", "error");
        }
      } catch (error) {
        ShowToast(error?.data?.message || "", "error");
      }
    },
  });

  const getAllCms = async () => {
    try {
      setLoading(true);
      const response = await getCms({}).unwrap();
      if (response?.status === 200) {
        setCmsData(response?.data);
        steDeliveryTime(response?.data?.time_details?.avg_delivery_time);
        formik.setValues({
          responseTime: response?.data?.time_details?.response_time || "",
          deliveryTime: response?.data?.time_details?.avg_delivery_time || "",
          deliveryFees: response?.data?.time_details?.delivery_fees || "",
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const getAllSupport = async (page) => {
    let body = {
      start: 1,
      length: 10,
      search: "",
    };

    try {
      const response = await allSupport(body).unwrap();
      if (response?.status === 200) {
        setSupportData(response?.data?.data);
        // setTotalRecords(response?.data?.total_records);
        // setTotalRecords(response?.data?.count);
      } else {
        setSupportData([]);
      }
    } catch (error) {
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const handleRevert = async (id) => {
    // Create the body object based on the status

    if (!response) {
      return;
    }

    const body = {
      answer: response,
    };

    try {
      const response = await vendorResponse({
        body,
        id: id,
      }).unwrap();
      if (response?.status === 200) {
        ShowToast("Response Sent Successfully", "success");
        setOpen(false);
        getAllSupport();
      } else {
        ShowToast("Please try again", "error");
      }
    } catch {
      ShowToast("Something went wrong", "error");
    }
  };

  const Job = ({ title, description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" fontWeight="medium">
        {title}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const columns = [
    { Header: t.main.name, accessor: "author", align: "left" },
    { Header: t.main.contact, accessor: "price", align: "left" },
    { Header: t.main.email, accessor: "status", align: "left" },

    { Header: t.main.query, accessor: "stock", align: "left" },
    { Header: t.main.actions, accessor: "action", align: "center" },
  ];

  const rows = supportData?.map((item) => ({
    author: <Job title={item?.fullname || "-"} />,
    price: <Job title={` ${item?.phone_no || "-"}`} />,
    status: <Job title={item?.email || "-"} />,

    stock: <Job title={item?.reason || "-"} />,
    action: (
      <MDBox>
        {item?.reverted_back ? (
          <MDBox sx={{ cursor: "pointer" }}>
            <MDBadge
              badgeContent="Reverted"
              color="success"
              variant="gradient"
              size="md"
            />
          </MDBox>
        ) : (
          <MDBox
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedId(item?.id);
              setOpen(true);
            }}
          >
            <MDBadge
              badgeContent="Revert"
              color="success"
              variant="gradient"
              size="md"
            />
          </MDBox>
        )}
      </MDBox>
    ),
  }));

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  useEffect(() => {
    getAllCms();
    getAllSupport();
  }, []);

  useEffect(() => {
    getAllFaqsHandler();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Loader loading={loading} />
        <Grid container spacing={2}>
          <Grid item xs={12} md={9} lg={9}>
            <Tabs
              value={tabValue}
              onChange={handleSetTabValue}
              orientation={tabsOrientation}
              className="custom_tabs_links"
            >
              <Tab
                icon={
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    help
                  </Icon>
                }
                label={t.main.helpAndSupport}
                {...a11yProps(0)}
                sx={{ fontWeight: "500" }}
              />
              <Tab
                sx={{ fontWeight: "500" }}
                icon={
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    quiz
                  </Icon>
                }
                label={t.main.faqs}
                {...a11yProps(1)}
              />
              <Tab
                sx={{ fontWeight: "500" }}
                icon={
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    policy
                  </Icon>
                }
                label={t.main.privacyPolicy}
                {...a11yProps(2)}
              />
              <Tab
                sx={{ fontWeight: "500" }}
                icon={
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    gavel
                  </Icon>
                }
                label={t.main.terms}
                {...a11yProps(3)}
              />
              <Tab
                sx={{ fontWeight: "500" }}
                icon={
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    gavel
                  </Icon>
                }
                label={t.main.generalSettings}
                {...a11yProps(4)}
              />
            </Tabs>
          </Grid>
        </Grid>
        <CustomTabPanel value={tabValue} index={0}>
          <Card sx={{ marginTop: 8 }}>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              // variant="gradient"
              bgColor="theme-1"
              borderRadius="lg"
              coloredShadow="info"
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              <MDTypography variant="h6" color="white">
                {t.main.helpAndSupport}
              </MDTypography>
            </MDBox>
            <MDBox pt={3}>
              <DataTable
                table={{ columns, rows }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
              />
            </MDBox>
          </Card>
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <Card sx={{ padding: 5, marginTop: 5 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <FAQSection faq={faq} getAllFaqsHandler={getAllFaqsHandler} />
              </Grid>
            </Grid>
          </Card>
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={2}>
          <Card sx={{ padding: 5, marginTop: 5 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <form>
                  <EditText
                    content={privacyPolicy}
                    setContent={setPrivacyPolicy}
                  />

                  <MDBox mt={2}>
                    <MDButton variant="gradient" color="success">
                      {t.main.save}
                    </MDButton>
                  </MDBox>
                </form>
              </Grid>
            </Grid>
          </Card>
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={3}>
          <Card sx={{ padding: 5, marginTop: 5 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <form>
                  <EditText
                    content={termsAndConditions}
                    setContent={setTermsAndConditions}
                  />

                  <MDBox mt={2}>
                    <MDButton variant="gradient" color="success">
                      {t.main.save}
                    </MDButton>
                  </MDBox>
                </form>
              </Grid>
            </Grid>
          </Card>
        </CustomTabPanel>

        <CustomTabPanel value={tabValue} index={4}></CustomTabPanel>

        {tabValue === 4 ? (
          <Card sx={{ padding: 5, marginTop: 5 }}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.responseTime}
                  </MDTypography>
                  <MDBox>
                    <MDInput
                      type="text"
                      placeholder={t.main.responseTime}
                      variant="outlined"
                      fullWidth
                      id="responseTime"
                      name="responseTime"
                      value={formik.values.responseTime}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.responseTime &&
                        formik.errors.responseTime
                      }
                      error={
                        formik.touched.responseTime &&
                        formik.errors.responseTime
                      }
                    />
                  </MDBox>
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.averageDeliveryTime}
                  </MDTypography>
                  <MDBox>
                    <MDInput
                      type="text"
                      placeholder={t.main.averageDeliveryTime}
                      variant="outlined"
                      fullWidth
                      id="deliveryTime"
                      name="deliveryTime"
                      value={formik.values.deliveryTime}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.deliveryTime &&
                        formik.errors.deliveryTime
                      }
                      error={
                        formik.touched.deliveryTime &&
                        formik.errors.deliveryTime
                      }
                    />
                  </MDBox>
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.deliveryFees}
                  </MDTypography>
                  <MDBox>
                    <MDInput
                      type="text"
                      placeholder={t.main.deliveryFees}
                      variant="outlined"
                      fullWidth
                      id="deliveryFees"
                      name="deliveryFees"
                      onChange={(val) => {
                        const value = val.target.value;
                        if (value === " " || value === ".") return;

                        // Regex to allow only numbers with up to two decimal places
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          formik.setFieldValue("deliveryFees", value);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.deliveryFees}
                      helperText={
                        formik.touched.deliveryFees &&
                        formik.errors.deliveryFees
                      }
                      error={
                        formik.touched.deliveryFees &&
                        formik.errors.deliveryFees
                      }
                    />
                  </MDBox>
                </Grid>
              </Grid>

              <MDButton
                variant="gradient"
                color="success"
                sx={{ marginTop: 4 }}
                type="submit"
              >
                {t.main.save}
              </MDButton>
            </form>
          </Card>
        ) : null}

        {/* <CustomTabPanel value={tabValue} index={1}>
          <Card sx={{ padding: 5, marginTop: 5 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                <FAQSection />
              </Grid>
            </Grid>
          </Card>
        </CustomTabPanel> */}
      </MDBox>

      <Dialog open={open} onClose={handleClose} className="revert_dialog">
        <DialogContent>
          <MDTypography variant="h5" fontWeight="medium" mb={1}>
            {t.main.revertToQuery}
          </MDTypography>
          <form>
            <FormControl fullWidth>
              <MDBox mb={2}>
                <MDTypography variant="subtitle 2">
                  {t.main.description}
                </MDTypography>
                <MDInput
                  type="text"
                  placeholder="Description"
                  variant="outlined"
                  fullWidth
                  value={response}
                  onChange={(val) => setResponse(val?.target?.value)}
                  error={error && !response}
                />
              </MDBox>
            </FormControl>
            <Box className="form_btn">
              <MDButton
                onClick={handleClose}
                variant="gradient"
                color="success"
                fullWidth
              >
                {t.main.cancel}
              </MDButton>
              <MDButton
                onClick={() => {
                  setError(true);
                  handleRevert(selectedId);
                }}
                variant="gradient"
                color="success"
                fullWidth
              >
                {t.main.save}
              </MDButton>
            </Box>
          </form>
        </DialogContent>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
};

export default Settings;
